import React, { useState, useEffect } from 'react';
import { Box, IconButton, Paper } from '@mui/material';
import { AlertCircle, ChevronLeft, ChevronRight } from 'lucide-react';
import useBreakpoints from 'src/utils/Breakpoints';

export default function BroadcastBanner({ currentMessage }) {
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const { isSm, isMd, isLg } = useBreakpoints()
    const tempCurrentMessage = currentMessage[currentMessageIndex];

    useEffect(() => {
        if (!isPaused && currentMessage.length > 1) {
            const interval = setInterval(() => {
                setCurrentMessageIndex((prev) =>
                    prev === currentMessage.length - 1 ? 0 : prev + 1
                );
            }, 5000);

            return () => clearInterval(interval);
        }
    }, [isPaused, currentMessage.length]);

    const handlePrevious = () => {
        setCurrentMessageIndex((prev) =>
            prev === 0 ? currentMessage.length - 1 : prev - 1
        );
    };

    const handleNext = () => {
        setCurrentMessageIndex((prev) =>
            prev === currentMessage.length - 1 ? 0 : prev + 1
        );
    };

    if (currentMessage.length === 0) return null;

    return (
        <Paper elevation={0} sx={{
            position: 'sticky',
            zIndex: 2,
            backgroundColor: 'white',
            // background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.93) 100%)',
            backdropFilter: 'blur(10px)',
            borderRadius: '0px',
            margin: "0px 0 0px 0",
            padding: '0px 20px 5px 24px',
            // width: `100%`,
            minWidth: '320px',
            maxWidth: '100%',
            transition: 'all 0.3s ease',
            // border: '0.1px solid rgba(0,0,0,0.3)',
            // boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            // '&:hover': {
            //     transform: 'translateY(-2px)',
            //     boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
            // }
        }}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                width: '100%'
            }}>
                <Box sx={{
                    animation: 'glow 2s ease-in-out infinite',
                    '@keyframes glow': {
                        '0%': { opacity: 1, transform: 'scale(1)', filter: 'brightness(1)' },
                        '50%': { opacity: 0.7, transform: 'scale(0.95)', filter: 'brightness(1.2)' },
                        '100%': { opacity: 1, transform: 'scale(1)', filter: 'brightness(1)' }
                    },
                    color: '#c62828',
                    display: 'flex',
                    alignItems: 'center',

                }}>
                    <AlertCircle size={22} style={{ padding: "1px 0 0 0" }} />
                </Box>

                <Box sx={{
                    flex: 1,
                    overflow: 'hidden',
                    position: 'relative'
                }}>
                    <Box sx={{
                        animation: !isPaused ? 'slide 60s linear infinite' : 'none',
                        '@keyframes slide': {
                            '0%': { transform: 'translateX(100%)' },
                            '100%': { transform: 'translateX(-100%)' }
                        },
                        whiteSpace: 'nowrap',
                        fontSize: isLg ? '18px' : isMd ? "0.9rem" : "0.8rem",
                        fontWeight: 600,
                        background: 'linear-gradient(135deg, #f44336 0%, #c62828 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        letterSpacing: '0.3px'
                    }}>
                        {tempCurrentMessage.Message}
                    </Box>
                </Box>

                {currentMessage.length > 1 && (
                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                        <IconButton
                            size="small"
                            onClick={handlePrevious}
                            sx={{
                                color: '#6366f1',
                                padding: '6px',
                                backgroundColor: 'rgba(99,102,241,0.05)',
                                '&:hover': {
                                    backgroundColor: 'rgba(99,102,241,0.1)',
                                    transform: 'scale(1.05)'
                                },
                                transition: 'all 0.2s ease'
                            }}
                        >
                            <ChevronLeft size={18} />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={handleNext}
                            sx={{
                                color: '#6366f1',
                                padding: '6px',
                                backgroundColor: 'rgba(99,102,241,0.05)',
                                '&:hover': {
                                    backgroundColor: 'rgba(99,102,241,0.1)',
                                    transform: 'scale(1.05)'
                                },
                                transition: 'all 0.2s ease'
                            }}
                        >
                            <ChevronRight size={18} />
                        </IconButton>
                    </Box>
                )}
            </Box>
        </Paper>
    );
}